import { render, staticRenderFns } from "./AddMedicalDocumentDialog.vue?vue&type=template&id=771eb9e6&scoped=true&lang=pug&"
import script from "./AddMedicalDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./AddMedicalDocumentDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddMedicalDocumentDialog.vue?vue&type=style&index=0&id=771eb9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771eb9e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCol,VDivider,VIcon,VRow,VSheet,VSkeletonLoader,VTextField})
